export const LOCAL_STORAGE_KEY = 'first-point';
export const SESSION_STORAGE_KEY = 'session-point';

export const phone = '+7 708 027 37 67';
export const email = 'e.lugina@andersenlab.com';
